import { BRAND } from '../palette';

/** Uppercase rule with a trailing hairline, matching the HTML section titles. */
export function SflSectionTitle({ children }: { children: string }) {
  return (
    <div
      className="flex items-center gap-3 mb-4"
      style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 11,
        letterSpacing: '2.5px',
        textTransform: 'uppercase',
        color: BRAND.textFaint,
      }}
    >
      {children}
      <span className="flex-1 h-px" style={{ background: BRAND.panelBorder }} aria-hidden="true" />
    </div>
  );
}
